import { LocaleService } from './LocaleService'
import { LocaleServiceAbstract } from './LocaleServiceAbstract'

export default new LocaleService() as LocaleServiceAbstract
